import { Box } from "@mui/material";
import {
  COACH_EXERCISE_LIBRARY_PUBLISHED_ROUTE,
  COACH_EXERCISE_LIBRARY_ARCHIVED_ROUTE,
  COACH_EXERCISE_LIBRARY_PENDING_ROUTE,
  COACH_EXERCISE_LIBRARY_TAGS_ROUTE,
} from "../../routes/routes";
import React from "react";
import { JourneyAnchors } from "../../constants";
import { CoachExerciseAssetsCount } from "../../contexts/CoachTabsContext";
import InlineCounter from "../loading/InlineCounter";

export const exerciseLibraryNavigation = (count: CoachExerciseAssetsCount) => [
  {
    name: "Published",
    link: COACH_EXERCISE_LIBRARY_PUBLISHED_ROUTE,
  },
  {
    name: (
      <Box className={JourneyAnchors.PENDING_EXERCISES_TAB}>
        <InlineCounter
          count={count.pending}
          label="Pending"
          loading={!count.pending && count.pending !== 0}
        />
      </Box>
    ),
    link: COACH_EXERCISE_LIBRARY_PENDING_ROUTE,
  },
  {
    name: "Archived",
    link: COACH_EXERCISE_LIBRARY_ARCHIVED_ROUTE,
  },
  {
    name: <Box className={JourneyAnchors.TAG_TAB}>Tags</Box>,
    link: COACH_EXERCISE_LIBRARY_TAGS_ROUTE,
  },
];
